import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {LicenseService} from '../../../services/license.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {LoadingPage} from '../../../../shared/components/loading/loading.page.component';

@Component({
  selector: 'app-google-slides',
  templateUrl: './google-slides.component.html',
  styleUrls: ['./google-slides.component.css']
})
export class GoogleSlidesComponent extends LoadingPage {

  deliverable;
  url: SafeResourceUrl;

  constructor(private route: ActivatedRoute,
              private licenseService: LicenseService,
              private sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit() {

    const deliverableId = this.route.snapshot.params['deliverableId'];
    this.loading();
    this.licenseService.getContent(deliverableId)
      .bindToLifecycle(this)
      .subscribe(({data}) => {
        this.deliverable = data;
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(data.googlePresentationEmbedLink);
        this.ready();
      }, err => this.error());
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/content/google-slides/google-slides.component.ts